/// <amd-module name="Search/Code/Components/TreeFilter" />
import * as React from "react";
import { LegacyComponent } from "VSS/Legacy/Legacy";
import { TimeoutComponent } from "Search/Shared/Components/TimeoutComponent";
import { IComboBoxProps, BaseTreeFilter } from "Search/Shared/Components/TreeDropdown";

export interface ITreeFilterProps extends IComboBoxProps {
    project?: string;

    repository?: string;

    branch?: string;

    onSelectionChanged(path: string): void;
}

export class TreeFilter extends BaseTreeFilter<ITreeFilterProps> {
    private searchable: boolean = false;

    public renderContent = (): JSX.Element => {
        const {
            project,
            repository,
            branch,
            comboBoxText,
            treeDropdownId
        } = this.props;
        return (
            <TimeoutComponent timeout={0}>
                <LegacyComponent
                    modules={["Search/Scenarios/Shared/Filters/VCPathFilter/LegacyTreeDropdown"]}
                    wrappedType="search.code.vcPathFilter"
                    {
                    ...{
                        treeDropdownId,
                        project,
                        repository,
                        branch,
                        requestedPath: comboBoxText,
                        onItemSelected: this.onSelectionChanged,
                        onGetPageHeight: this.onGetPageHeight,
                        onGetPageWidth: this.onGetPageWidth,
                        onDidMount: this.onDropdownMounted,
                        onChanged: this.onChanged,
                        onItemNavigated: this.onItemNavigated
                    }
                    }
                />
            </TimeoutComponent>
        );
    }

    public applyPath = (): void => {      
        const { textBoxInput } = this.state;
        const trimmedTextBoxInput = textBoxInput ? textBoxInput.trim() : undefined;
        const input = trimmedTextBoxInput || "/";
        this.props.onSelectionChanged(input);
    }

    public isSearchAble = (): boolean => {
        return this.searchable;
    }

    private onGetPageHeight = (): number => {
        const searchPageElements: HTMLCollectionOf<Element> = document.getElementsByClassName("search-results");
        return searchPageElements[0].clientHeight;
    }

    private onGetPageWidth = (): number => {
        const searchPageElements: HTMLCollectionOf<Element> = document.getElementsByClassName("search-results");
        return searchPageElements[0].clientWidth;
    }

    private onChanged = (isLazyMode: boolean): void => {
        this.searchable = !isLazyMode;

        this.setState({ searching: false });
    }

    private onDropdownMounted = (
        onSearch: (text: string) => void,
        onNavigate: (isUp: boolean) => void,
        onExpand: () => boolean,
        onCollapse: () => boolean): void => {
        this.executeSearch = onSearch;
        this.navigate = onNavigate;
        this.expand = onExpand;
        this.collapse = onCollapse;
    }

    private onItemNavigated = (path?: string): void => {
        let text = path ? path : this.props.comboBoxText || this.lastSearchText;
        this.setState({ textBoxInput: text || "" });
    }

    private onSelectionChanged = (path: string): void => {
        this.setState({ dropdownActive: false }, () => {
            this.props.onSelectionChanged(path);
        })
    }
}
